(function () {
  'use strict';

  var designMode = window.Shopify && window.Shopify.designMode;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============================================================
     Scroll reveal — IntersectionObserver
  ============================================================ */
  function initReveal() {
    var els = document.querySelectorAll('[data-aly-reveal]');
    if (!els.length) return;

    if (designMode) {
      els.forEach(function (el) { el.setAttribute('data-aly-visible', 'true'); });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.setAttribute('data-aly-visible', 'true'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.setAttribute('data-aly-visible', 'true');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });

    els.forEach(function (el) { obs.observe(el); });
  }

  /* ============================================================
     FAQ accordion
  ============================================================ */
  function initFAQ() {
    document.querySelectorAll('.aly-faq-item button').forEach(function (btn) {
      if (btn._alyFaq) return;
      btn._alyFaq = true;
      btn.addEventListener('click', function () {
        var item = btn.closest('.aly-faq-item');
        var isOpen = item.classList.contains('is-open');
        document.querySelectorAll('.aly-faq-item.is-open').forEach(function (open) {
          open.classList.remove('is-open');
          open.querySelector('button').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ============================================================
     Hero background parallax (native rAF)
  ============================================================ */
  function initHeroParallax() {
    if (reduceMotion || designMode) return;
    var bg = document.querySelector('.aly-hero-bg');
    if (!bg) return;
    var hero = bg.closest('.alyntia-hero');
    if (!hero) return;

    var ticking = false;
    function update() {
      var rect = hero.getBoundingClientRect();
      var progress = -rect.top / (rect.height || 1);
      bg.style.transform = 'translateY(' + (progress * 15) + '%)';
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ============================================================
     GSAP ScrollTrigger — Node parallax
     Loads GSAP from CDN dynamically so no Liquid changes needed.
     Each node drifts at a unique x/y speed creating depth effect.
  ============================================================ */
  function initNodeParallax() {
    if (reduceMotion || designMode) return;
    var nodes = document.querySelectorAll('.aly-node-g');
    if (!nodes.length) return;

    function loadScript(src, cb) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = cb;
      s.onerror = function () {};
      document.head.appendChild(s);
    }

    function run() {
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
      gsap.registerPlugin(ScrollTrigger);

      var hero = document.querySelector('.alyntia-hero');
      if (!hero) return;

      /* Kill any previous ScrollTrigger instances on these nodes */
      ScrollTrigger.getAll().forEach(function (t) {
        if (t.vars && t.vars._alyNode) t.kill();
      });

      var nodeArr = Array.from(nodes);
      nodeArr.forEach(function (node, i) {
        /* Golden-angle spread so nodes fan out evenly */
        var angle = (i * 137.508) % 360;
        var rad   = angle * Math.PI / 180;

        /* Drift distance varies by position in list — closer nodes move more */
        var dist  = 24 + (i % 5) * 14;          /* 24–80 px */
        var xDrift = Math.sin(rad) * dist;        /* left/right */
        var yDrift = -(16 + (i % 4) * 12);       /* always float upward */
        var scaleDrift = 0.65 + (i % 4) * 0.08;  /* shrink slightly */
        var opacityTo  = 0.05 + (i % 3) * 0.12;  /* fade out */

        gsap.fromTo(node,
          { x: 0, y: 0, scale: 1, opacity: 1 },
          {
            x: xDrift,
            y: yDrift,
            scale: scaleDrift,
            opacity: opacityTo,
            ease: 'none',
            scrollTrigger: {
              _alyNode: true,          /* marker so we can find/kill them */
              trigger: hero,
              start: 'top top',
              end: 'bottom top',
              scrub: 1.8,
            }
          }
        );
      });
    }

    /* If GSAP is already on the page (e.g. theme uses it), run immediately */
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      run();
      return;
    }

    /* Otherwise load both scripts sequentially from cdnjs */
    var GSAP_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
    var ST_CDN   = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
    loadScript(GSAP_CDN, function () {
      loadScript(ST_CDN, run);
    });
  }

  /* ============================================================
     Bootstrap
  ============================================================ */
  function init() {
    initReveal();
    initFAQ();
    initHeroParallax();
    initNodeParallax();
  }

  /* Re-init after Shopify editor section reloads */
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initFAQ();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
